function replaceVariantsOptions(query) {
    const regex = /[0-9]+\/[0-9]+\s/ig;
    const options = document.querySelectorAll(query);

    options.forEach(option => {
        if (regex.test(option.innerText)) {
            option.innerText = option.innerText.toString().replaceAll(regex, '')
        }
    })
}

function isCurrentEnvironmentZip(zipcode, config) {
    // check if zipcode is available else redirect where is function called
    const zipCodesVariables = [
        config.connecticut_zip_codes,
        config.zip_codes,
        config.delivery_zip_codes,
        config.same_day_delivery,
        config.geofencing_zipcodes,
        config.disabled_zip_codes
    ];

    let isCurrentEnvZip = false;

    zipCodesVariables.forEach(el => {
        if ($.inArray(zipcode, el) !== -1) {
            isCurrentEnvZip = true;
        }
    })

    return isCurrentEnvZip;
}

function findZipEnvironment(zipcode, zipcodesConfig) {
    // find zipcode environment
    let environment;

    Object.keys(zipcodesConfig).forEach(config => {
        if (zipcodesConfig[config] && zipcodesConfig[config].published && isCurrentEnvironmentZip(zipcode, zipcodesConfig[config]) && !environment) {
            environment = zipcodesConfig[config];
        }
    })

    return environment;
}

function getZipcodesConfig() {
    fetch('https://cdn.shopify.com/s/files/1/0556/9698/2069/files/zipcodes.json?v=' + new Date().getTime()).then( (res) => {
        return res.json();
    }).then((body) => {
        sessionStorage.setItem('allStatesZipcodes', JSON.stringify(body));
        sessionStorage.setItem('currentZipcodes', JSON.stringify(body.runTheJewels));
    });
}

function getAllStatesZipcodes() {
    return JSON.parse(sessionStorage.getItem('allStatesZipcodes'))
}

function getCurrentStateZipcodes() {
    return JSON.parse(sessionStorage.getItem('currentZipcodes'))
}

